module.exports = __webpack_public_path__ + "img/21.f7c47c34.jpg";